import React, { useEffect, useState, useMemo } from "react";
import { useFormik } from "formik";
import { useOfferFormContext } from "../OfferFormContext";
import PrimaryButton from "../../PrimaryButton";
import GreyButton from "../../GreyButton";
import { locationOfferSchema } from "../../../../utils/validationSchemas";
import SelectOption from "../SelectOption";
import AddNewLocation from "./AddNewLocation";
import { useDispatch, useSelector } from "react-redux";
import { getFranchises, addFranchise } from "../../../../services/franchiseService";
import { createOffer } from "../../../../services/offerService";
import Checkbox from "../../Checkbox";
import { ReactComponent as UncheckedIcon } from "../../../../Assets/Icons/uncheckedBlueStrong.svg";
import LocationIcon from "../../../../Assets/Icons/Location.svg";
import RadioSelection from "../../RadioSelection";
import CSVUpload from "../CSVUpload";
import toast from "../../../../utils/toast";
import { uploadFile } from "../../../../utils/s3";
import { Modal, Drawer, Tooltip } from "antd";
import { ReactComponent as TickIcon } from "../../../../Assets/Icons/whiteplaintick.svg";
import { ReactComponent as CSVIcon } from "../../../../Assets/Icons/csvupload.svg";
import { ReactComponent as BackArrow } from "../../../../Assets/Icons/backWhiteIcon.svg";
import { ReactComponent as CloseIconModal } from "../../../../Assets/Icons/popupCloseIcon.svg";
import { ReactComponent as GreyCross } from "../../../../Assets/Icons/greyCross.svg";
import UploadCSVDrawer from "./UploadCSVDrawer";
import "./ViewAllModal.scss";
import { scrollToFirstError } from "../../../../utils/utilFunctions";

const Location = ({
    stepIndex,
    setStepIndex,
    handlePrevious,
    setPayloadData,
    editOfferData,
    isEdit,
    selectedMerchant,
    handleSaveAndExit,
}) => {
    const dispatch = useDispatch();
    const loading = useSelector((state) => state?.franchiseReducer?.loading);
    const offerData = useSelector((state) => state?.offerReducer?.createdOffer);
    const role = useSelector(
        (state) => state?.authReducer?.tokenData?.user?.role
    );
    const { registerNextAction, setIsNextLoading, setIsNextDisabled } = useOfferFormContext();
    console.log(offerData, "offerData1234567890=++");
    const [locations, setLocations] = useState([]);
    console.log(locations, "locations1234567890=++");
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [selectedLocationIds, setSelectedLocationIds] = useState([]);
    const [locationNames, setLocationNames] = useState([]);
    const [csvLocations, setCsvLocations] = useState([]);
    const [tempCsvSelection, setTempCsvSelection] = useState([]);
    const [addClicked, setAddClicked] = useState(false);
    const [uploadClicked, setUploadClicked] = useState(false);
    const [csvDrawerOpen, setCsvDrawerOpen] = useState(false);
    const [allStores, setAllStores] = useState(false);
    const [fileloading, setFileLoading] = useState(false);
    const [fileUrl, setFileUrl] = useState(null);
    const [fileData, setFileData] = useState();
    const [viewAllVisible, setViewAllVisible] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);

    // Persist selection across steps (and refresh) scoped to current offer id
    const STORAGE_KEY = React.useMemo(
        () => (offerData?._id ? `OFFER_LOCATION_STATE_${offerData._id}` : null),
        [offerData?._id]
    );

    useEffect(() => {
        if (offerData?.availableAcrossAllStores !== undefined) {
            setAllStores(offerData.availableAcrossAllStores);
        }
    }, [offerData]);

    // Rehydrate saved selection once locations are loaded
    useEffect(() => {
        if (!STORAGE_KEY) return;
        try {
            const raw = sessionStorage.getItem(STORAGE_KEY);
            if (!raw) return;
            const saved = JSON.parse(raw);

            // If we have saved temporary (CSV) locations, restore them to the main list first
            if (Array.isArray(saved?.locations)) {
                setLocations(prev => {
                    // Keep existing real ones + saved ones (avoiding duplicates)
                    const existingIds = new Set(prev.map(l => l?._id));
                    const newOnes = saved.locations.filter(l => l?._id && !existingIds.has(l._id));
                    return [...newOnes, ...prev];
                });
            }

            if (Array.isArray(saved?.selectedLocationIds)) {
                setSelectedLocationIds(saved.selectedLocationIds);
                // We'll sync objects and names once locations list is updated
            }
            if (typeof saved?.allStores === 'boolean') {
                setAllStores(saved.allStores);
            }
        } catch (_) { }
    }, [STORAGE_KEY]);

    // Secondary effect to sync objects once IDs and Locations are present
    useEffect(() => {
        if (selectedLocationIds.length > 0 && locations.length > 0) {
            const currentObjects = selectedLocationIds
                .map(id => locations.find(l => l?._id === id))
                .filter(Boolean);

            // Only update if actually different to avoid cycles
            if (currentObjects.length !== selectedLocations.length) {
                setSelectedLocations(currentObjects);
                setLocationNames(currentObjects.map(l => l?.name));
            }
        }
    }, [selectedLocationIds, locations]);

    const validateFile = (data) => {
        var idxDot = data.lastIndexOf(".") + 1;
        var extFile = data.substr(idxDot, data.length).toLowerCase();
        if (extFile == "csv" || extFile == "xlsx" || extFile == "xls") {
            return true;
        } else {
            return false;
        }
    };
    const handleAcceptedFiles = async (event) => {
        const file = event.target.files[0];
        console.log("file", file);
        if (validateFile(file?.name)) {
            setFileLoading(true);
            const reader = new FileReader();
            reader.onload = (e) => {
                const text = e.target.result;
                const lines = text.split("\n");

                // Split a CSV line by commas while respecting quoted fields
                const splitCsvLine = (line) => {
                    const matches = line
                        .trim()
                        .match(/("[^"]*"|[^,]+)(?=,|$)/g);
                    if (!matches) return [];
                    return matches.map((m) => m.replace(/^"|"$/g, "").trim());
                };

                const headers = (splitCsvLine(lines[0]) || [])
                    .map((h) => h.trim().toLowerCase());
                const locationData = lines
                    .slice(1) // Skip header row
                    .filter((line) => line.trim() !== "") // Remove empty lines
                    .map((line) => {
                        const columns = splitCsvLine(line);
                        // Create working hours array
                        const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
                        const workingHours = days.map((day) => ({
                            day: day,
                            openTime: columns[headers.indexOf(`${day}_open`)] || "",
                            closeTime: columns[headers.indexOf(`${day}_close`)] || "",
                        })).filter(day => day.openTime || day.closeTime);

                        return {
                            name: columns[headers.indexOf("name")] || "",
                            email: columns[headers.indexOf("email")] || "",
                            address: columns[headers.indexOf("address")] || "",
                            phone: columns[headers.indexOf("phone")] || "",
                            // Generate a temporary ID for new locations
                            _id: `temp_${Date.now()}_${Math.random()
                                .toString(36)
                                .substr(2, 9)}`,
                            googlePlaceId: columns[headers.indexOf("googleplaceid")] || null,
                            workingHours: workingHours,
                        };
                    })
                    .filter((location) => location.name && location.address); // Only include locations with name and address

                if (locationData.length > 0) {
                    // Set CSV locations for sidebar staging
                    setCsvLocations(locationData);

                    // Auto-select in the sidebar (staging area only)
                    setTempCsvSelection(locationData.map(l => l._id));

                    setFieldValue("document", file?.name);
                    toast.success(
                        `${locationData.length} location(s) loaded. Please select locations to add.`
                    );
                } else {
                    toast.error(
                        "No valid locations found in the CSV file. Please ensure the file has the required columns."
                    );
                    handleRejectedFiles(file, true);
                }
                setFileLoading(false);
            };

            reader.onerror = () => {
                toast.error("Error reading the CSV file");
                handleRejectedFiles(file, true);
                setFileLoading(false);
            };

            reader.readAsText(file);
        } else {
            toast.error(`Only .csv, .xls, and .xlsx files are allowed!`);
            handleRejectedFiles(file, true);
        }
    };

    const handleRejectedFiles = (filesOrFile, silent = false) => {
        const file = Array.isArray(filesOrFile)
            ? filesOrFile[0]
            : filesOrFile;
        setFileData(null);
        setFieldValue("document", null);
        if (silent) return;
        if (file?.errors) {
            file?.errors?.forEach((error) => {
                toast.error(error.message);
            });
        } else {
            toast.error("Invalid file format. Please upload a valid CSV file.");
        }
    };

    const handleClear = () => {
        setFileUrl(null);
        setFileData(null);
        setFieldValue("document", "");

        // Only clear the staging area - don't touch locations that have already been added to the main list
        setCsvLocations([]);
        setTempCsvSelection([]);
    };

    const fillUpForm = (data) => {
        if (data?.tempLocations) {
            const locObjects = [];
            const locIds = [];
            const locNames = [];

            data.tempLocations?.map((location) => {
                locObjects?.push(location);
                locIds?.push(location?._id);
                locNames?.push(location?.name);
            });

            setSelectedLocations(locObjects);
            setSelectedLocationIds(locIds);
            setLocationNames(locNames);
        }
    };

    useEffect(() => {
        if (editOfferData !== null && isEdit == true) {
            fillUpForm(editOfferData);
        } else {
            fillUpForm(offerData);
        }
    }, [offerData, editOfferData]);

    const getAllFranchises = async () => {
        const franchisePromise = await dispatch(role == "admin" ? getFranchises({ merchant: selectedMerchant?._id }) : getFranchises()).unwrap();
        if (franchisePromise?.success === true) {
            setLocations(franchisePromise?.data);
        }
    };

    useEffect(() => {
        getAllFranchises();
    }, []);

    const initialValues = {
        location: [],
        locationAdded: "Add a new location",
        document: "",
    };

    const payload = {
        locations: allStores ? [] : selectedLocationIds,
        availableAcrossAllStores: allStores,
        offerId: offerData?._id,
        merchantId: selectedMerchant?._id,
        offerType: offerData?.offerType,
        isCreated: false,
    };

    useEffect(() => {
        setPayloadData(payload);
    }, [selectedLocationIds, offerData?._id, allStores]);

    // Persist whenever selection or location list changes (to keep temps)
    useEffect(() => {
        if (!STORAGE_KEY) return;
        try {
            sessionStorage.setItem(
                STORAGE_KEY,
                JSON.stringify({
                    selectedLocationIds,
                    allStores,
                    locations: locations.filter(l => String(l?._id || "").startsWith("temp_"))
                })
            );
        } catch (_) { }
    }, [STORAGE_KEY, selectedLocationIds, allStores, locations]);

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: locationOfferSchema(allStores),
        enableReinitialize: true,

        onSubmit: async (values) => {
            setSaveLoading(true);
            try {
                // 1) Handle temporary locations resolution
                const tempSelected = selectedLocations.filter((l) => String(l?._id || "").startsWith("temp_"));
                let resolvedIds = selectedLocationIds.filter(id => !String(id || "").startsWith("temp_"));
                let resolvedObjs = selectedLocations.filter(l => !String(l?._id || "").startsWith("temp_"));

                if (tempSelected.length > 0) {
                    // Normalize phone for comparison
                    const normalizePhone = (p) => {
                        const digits = String(p || "").replace(/\D/g, "");
                        return digits.length > 9 ? digits.slice(-9) : digits;
                    };

                    const existingList = Array.isArray(locations) ? locations : [];

                    const toCreate = tempSelected.filter((t) => {
                        const tPhone = normalizePhone(t?.phone);
                        const match = existingList.find((x) => {
                            if (String(x?._id || "").startsWith("temp_")) return false;
                            const xAddr = (x?.googlePlaceId?.address || x?.address || "").trim().toLowerCase();
                            const tAddr = (t?.googlePlaceId?.address || t?.address || "").trim().toLowerCase();
                            const sameName = String(x?.name || "").trim().toLowerCase() === String(t?.name || "").trim().toLowerCase();
                            const sameAddr = xAddr === tAddr && xAddr !== "";
                            const samePhone = tPhone !== "" && normalizePhone(x?.phone) === tPhone;
                            return (sameName && sameAddr) || samePhone;
                        });

                        if (match) {
                            if (!resolvedIds.includes(match._id)) {
                                resolvedIds.push(match._id);
                                resolvedObjs.push(match);
                            }
                            return false;
                        }
                        return true;
                    });

                    if (toCreate.length > 0) {
                        try {
                            const bulkPayload = {
                                locations: toCreate.map((l) => ({
                                    name: l?.name,
                                    email: l?.email || "",
                                    phone: l?.phone || "",
                                    googlePlaceId: l?.googlePlaceId || null,
                                    tradingHours: l?.workingHours || l?.tradingHours || undefined,
                                })),
                            };
                            const addRes = await dispatch(addFranchise(bulkPayload)).unwrap();
                            if (addRes?.success && Array.isArray(addRes.data)) {
                                addRes.data.forEach(newLoc => {
                                    if (!resolvedIds.includes(newLoc._id)) {
                                        resolvedIds.push(newLoc._id);
                                        resolvedObjs.push(newLoc);
                                    }
                                });
                            } else if (addRes?.success && addRes.data?._id) {
                                // Single obj case just in case
                                resolvedIds.push(addRes.data._id);
                                resolvedObjs.push(addRes.data);
                            }
                        } catch (err) {
                            console.error("Bulk add failed:", err);
                            // Error is likely handled by interceptor (toast), so we stop here
                            setSaveLoading(false);
                            return;
                        }
                    }

                    // Update local state to reflect resolved real IDs
                    setSelectedLocationIds(resolvedIds);
                    setSelectedLocations(resolvedObjs);
                    setLocationNames(resolvedObjs.map(l => l?.name));
                }

                // 2) Finalize offer with REAL IDs
                const createPromise = await dispatch(
                    createOffer({
                        locations: allStores ? [] : resolvedIds,
                        availableAcrossAllStores: allStores,
                        offerId: offerData._id,
                        merchantId: selectedMerchant?._id,
                        offerType: offerData.offerType,
                    })
                )?.unwrap();

                if (createPromise?.success === true) {
                    const nextStep = role === "admin" ? 8 : 7;
                    setStepIndex(nextStep);
                }
            } catch (error) {
                console.error("Final submit error:", error);
            } finally {
                setSaveLoading(false);
            }
        },
    });

    const { location, locationAdded, document } = formik.values;

    const {
        handleChange,
        handleBlur,
        errors,
        touched,
        setFieldValue,
        handleSubmit,
        setValues,
    } = formik;

    const attemptNext = async () => {
        formik.setTouched({ location: true });
        const validationErrors = await formik.validateForm();
        if (Object.keys(validationErrors || {}).length > 0) {
            scrollToFirstError(validationErrors, ["location"]);
            return;
        }
        formik.handleSubmit();
    };

    // Register the Next action for the Layout's Next button
    useEffect(() => {
        registerNextAction(() => attemptNext());
    }, [registerNextAction, formik.values, selectedLocationIds, allStores, locations]);

    // Sync loading state with Layout's Next button
    useEffect(() => {
        setIsNextLoading(loading);
    }, [loading, setIsNextLoading]);

    // Update disabled state for Next button
    useEffect(() => {
        setIsNextDisabled(!allStores && selectedLocationIds.length === 0);
    }, [allStores, selectedLocationIds, setIsNextDisabled]);

    const handleClick = (id, name, location) => {
        const isSelected = selectedLocations?.find((loc) => loc?._id === id);

        if (isSelected) {
            const updatedLocations = selectedLocations?.filter(
                (loc) => loc?._id !== id
            );
            setSelectedLocations(updatedLocations);

            const updatedIds = selectedLocationIds?.filter((locId) => locId !== id);
            setSelectedLocationIds(updatedIds);

            const updatedNames = locationNames?.filter((t) => t !== name);
            setLocationNames(updatedNames);
        } else {
            const loc = locations?.find((l) => l?._id === id);
            setSelectedLocations((prev) => [...prev, loc]);
            setSelectedLocationIds((prev) => [...prev, loc?._id]);
            setLocationNames((prev) => [...prev, loc?.name]);
        }
    };

    const isLocationClicked = (id) => {
        return selectedLocationIds?.includes(id);
    };

    const handleAddClick = () => {
        setAddClicked(true);
        setUploadClicked(false);
    };

    const handleUploadClick = () => {
        if (addClicked == true) {
            setUploadClicked(true);
        }
    };

    useEffect(() => {
        setFieldValue("location", locationNames);
    }, [locationNames]);

    // Clear validation errors when allStores becomes true
    useEffect(() => {
        if (allStores && formik.errors.location) {
            formik.setFieldError("location", undefined);
        }
    }, [allStores]);

    // Disable "Available Across All Stores" when no locations exist
    useEffect(() => {
        if (locations?.length === 0 && allStores) {
            setAllStores(false);
        }
    }, [locations?.length, allStores]);

    const handleSaveExit = async () => {
        if (typeof handleSaveAndExit === 'function') {
            await handleSaveAndExit();
        } else {
            console.warn('handleSaveAndExit not provided to Location component');
        }
    };

    const handleLocationToggle = (id, name, locationObj) => {
        const isSelected = selectedLocationIds?.includes(id);

        if (isSelected) {
            // When unselecting any location, "All Stores" requirement is no longer met
            setAllStores(false);

            setSelectedLocations(prev => prev.filter(loc => loc?._id !== id));
            setSelectedLocationIds(prev => prev.filter(locId => locId !== id));
            setLocationNames(prev => prev.filter(t => t !== name));

            // If it's a temp location, remove it from the main list as well when unselected
            if (String(id).startsWith("temp_")) {
                setLocations(prev => prev.filter(l => l._id !== id));
            }
        } else {
            // Check if location is already in the main list
            const existingLoc = locations?.find(l => l?._id === id);

            // If not in main list but provided (e.g. from CSV drawer), add it
            if (!existingLoc && locationObj && String(id).startsWith("temp_")) {
                setLocations(prev => [locationObj, ...prev]);
                // Use the object passed
                setSelectedLocations(prev => [...prev, locationObj]);
                setSelectedLocationIds(prev => [...prev, id]);
                setLocationNames(prev => [...prev, name]);
            } else if (existingLoc) {
                // Standard selection of existing location
                setSelectedLocations(prev => [...prev, existingLoc]);
                setSelectedLocationIds(prev => [...prev, existingLoc?._id]);
                setLocationNames(prev => [...prev, existingLoc?.name]);
            }
        }
    };

    const handleAllStoresToggle = () => {
        if (locations?.length > 0) {
            const nextAllStores = !allStores;
            setAllStores(nextAllStores);
            if (nextAllStores) {
                setSelectedLocationIds(locations.map(l => l._id));
                setSelectedLocations(locations);
                setLocationNames(locations.map(l => l.name));
            } else {
                setSelectedLocationIds([]);
                setSelectedLocations([]);
                setLocationNames([]);
            }
        }
    };

    useEffect(() => {
        setFieldValue("location", locationNames);
    }, [locationNames]);

    const isNextButtonBusy = Boolean(loading);
    const isNextButtonDisabled = isNextButtonBusy ||
        (!allStores && (selectedLocationIds.length === 0 || !formik.values.location || (Array.isArray(formik.values.location) && formik.values.location.length === 0)));

    const nextButtonLabel = isNextButtonBusy ? (
        <span className="flex items-center justify-center gap-2">
            <span className="offer-btn-spinner" />
            <span>Processing...</span>
        </span>
    ) : (
        "Next"
    );

    const handleBatchLocationSelection = (locs, isSelected) => {
        if (isSelected) {
            // Add all that are not already selected
            const newLocs = locs.filter(l => !selectedLocationIds.includes(l._id));
            if (newLocs.length > 0) {
                setSelectedLocations(prev => [...prev, ...newLocs]);
                setSelectedLocationIds(prev => [...prev, ...newLocs.map(l => l._id)]);
                setLocationNames(prev => [...prev, ...newLocs.map(l => l.name)]);
            }
        } else {
            // Remove all
            const idsToRemove = locs.map(l => l._id);

            setSelectedLocations(prev => prev.filter(l => !idsToRemove.includes(l._id)));
            setSelectedLocationIds(prev => prev.filter(id => !idsToRemove.includes(id)));
            const namesToRemove = locs.map(l => l.name);
            setLocationNames(prev => prev.filter(n => !namesToRemove.includes(n)));
        }
    };

    // Handlers for the CSV Drawer Staging Area
    const handleTempSelectionToggle = (id, _name, _loc) => {
        setTempCsvSelection(prev => {
            if (prev.includes(id)) {
                return prev.filter(x => x !== id);
            } else {
                return [...prev, id];
            }
        });
    };

    const handleBatchTempSelection = (locs, isSelected) => {
        const ids = locs.map(l => l._id);
        if (isSelected) {
            setTempCsvSelection(prev => {
                const unique = new Set([...prev, ...ids]);
                return Array.from(unique);
            });
        } else {
            setTempCsvSelection(prev => prev.filter(id => !ids.includes(id)));
        }
    };

    const handleConfirmAdd = () => {
        const toAdd = csvLocations.filter(l => tempCsvSelection.includes(l._id));

        // Filter out duplicates (based on ID)
        const currentIds = locations.map(l => l._id);
        const uniqueToAdd = toAdd.filter(l => !currentIds.includes(l._id));

        if (uniqueToAdd.length > 0) {
            setLocations(prev => [...uniqueToAdd, ...prev]);
            setSelectedLocations(prev => [...uniqueToAdd, ...prev]);
            setSelectedLocationIds(prev => [...uniqueToAdd.map(l => l._id), ...prev]);
            setLocationNames(prev => [...uniqueToAdd.map(l => l.name), ...prev]);
        }

        // Clear the CSV staging area after adding
        setCsvLocations([]);
        setTempCsvSelection([]);
        setFileUrl(null);
        setFileData(null);
        setFieldValue("document", "");

        setCsvDrawerOpen(false);
    };

    const displayedLocations = useMemo(() => {
        return locations.slice(0, 4);
    }, [locations]);

    const hasMore = locations.length > 4;

    return (
        <div className="w-full offer-locations-step mt-10 px-4">
            {/* Save and Exit in top right */}
            <div className="w-full max-w-[1100px] mx-auto relative">
                <div className="absolute top-[-75px] right-0">
                    <button
                        onClick={handleSaveExit}
                        className="px-6 h-[40px] border border-[#00ADEF] rounded-[5px] text-[#00ADEF] text-[14px] font-[500] font-poppins hover:bg-[#F0FBFF] transition-all"
                        disabled={saveLoading}
                        type="button"
                    >
                        {saveLoading ? "Saving..." : "Save and Exit"}
                    </button>
                </div>
            </div>

            <div className="sm:w-[100%] md:w-[90%] lg:w-[85%] xl:w-[65%] mx-auto">
                <div className="locations-header">
                    <h2>Choose Your <span>Store Locations</span></h2>
                    <p>Select the store locations where customers can redeem this offer.</p>
                </div>
                {locations.length === 0 ? (
                    <div className="empty-locations-container">
                        <div className="empty-locations-graphic">
                            <div className="placeholder-bar"><div className="shape pin" /><div className="line long" /></div>
                            <div className="placeholder-bar"><div className="shape pin" /><div className="line long" /></div>
                            <div className="placeholder-bar"><div className="shape pin" /><div className="line long" /></div>
                        </div>
                        <div className="empty-locations-text">
                            <h4>No Store Locations Added Yet</h4>
                            <p>You haven't added any Store locations yet. Add one to proceed.</p>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="all-stores-card">
                            <div className="card-inner">
                                <Checkbox
                                    text="Available Across All Stores"
                                    divClassName="flex items-center"
                                    checked={allStores}
                                    onChecked={handleAllStoresToggle}
                                    disabled={locations?.length === 0}
                                    textClass={`text-[15px] font-[600] font-poppins ml-2 text-[#303030]`}
                                    checkClassName="all-stores-checkbox"
                                    UncheckedIcon={UncheckedIcon}
                                />
                                <p>This applies to all stores added, ensuring your offer reaches every location.</p>
                            </div>
                        </div>

                        <div className="locations-selection-card" data-field="location">
                            <div className="card-header">
                                <label>Choose the Location for This Offer<span>*</span></label>
                                <span className="selected-count">{selectedLocationIds.length} Selected</span>
                            </div>
                            <div className="locations-list">
                                {displayedLocations.map((loc) => (
                                    <div
                                        key={loc._id}
                                        className={`store-location-item ${selectedLocationIds.includes(loc._id) ? 'selected' : ''}`}
                                        onClick={() => handleLocationToggle(loc._id, loc.name, loc)}
                                    >
                                        <div className={`checkbox-mini ${selectedLocationIds.includes(loc._id) ? 'checked' : ''}`}>
                                            {selectedLocationIds.includes(loc._id) && <TickIcon />}
                                        </div>
                                        <span className="address-text">{loc?.googlePlaceId?.address || loc?.address}</span>
                                    </div>
                                ))}
                            </div>
                            {hasMore && (
                                <span className="view-all-link" onClick={() => setViewAllVisible(true)}>
                                    View All
                                </span>
                            )}
                            {formik.errors.location && formik.touched.location && (
                                <span className="text-red-500 text-[12px] mt-2 block font-medium ms-1">
                                    {formik.errors.location}
                                </span>
                            )}
                        </div>
                    </>
                )}

                {/* Add Store Section */}
                <div className="add-store-section">
                    <label className="section-label">Add Store Location<span>*</span></label>
                    <div className="actions-grid">
                        <div className={`action-card animate-on-load ${addClicked ? 'active' : ''}`} onClick={() => setAddClicked(true)}>
                            <div className="icon-box">
                                <img src={LocationIcon} alt="location" />
                            </div>
                            <span className="action-title">Add A New Store Location</span>
                        </div>
                        <div className={`action-card csv-card animate-on-load ${csvDrawerOpen ? 'active' : ''}`} onClick={() => setCsvDrawerOpen(true)}>
                            <div className="icon-box">
                                <CSVIcon />
                            </div>
                            <span className="action-title">Upload Via CSV</span>
                        </div>
                    </div>
                </div>

            </div>

            {/* View All Modal */}
            <Modal
                open={viewAllVisible}
                onCancel={() => setViewAllVisible(false)}
                footer={null}
                width={window.innerWidth < 640 ? "95%" : 600}
                centered
                closeIcon={<CloseIconModal />}
                className="view-all-locations-modal"
            >
                <div className="modal-card-wrapper">
                    <div className="modal-custom-header">
                        <h2 className="modal-title">Current Locations</h2>
                        <span className="selected-count">{selectedLocationIds.length} Selected</span>
                    </div>
                    <div className="locations-scroll-area">
                        {locations.map((loc) => (
                            <div
                                key={loc._id}
                                className={`store-location-item ${selectedLocationIds.includes(loc._id) ? 'selected' : ''}`}
                                onClick={() => handleLocationToggle(loc._id, loc.name, loc)}
                            >
                                <div className={`checkbox-mini ${selectedLocationIds.includes(loc._id) ? 'checked' : ''}`}>
                                    {selectedLocationIds.includes(loc._id) && <TickIcon />}
                                </div>
                                <span className="address-text">{loc?.googlePlaceId?.address || loc?.address}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </Modal>

            {/* Add Location Drawer */}
            <Drawer
                placement="right"
                onClose={() => setAddClicked(false)}
                open={addClicked}
                width={window.innerWidth < 640 ? "100%" : 520}
                className="add-store-drawer add-location-sidebar"
                rootClassName="modern-drawer-root"
                closeIcon={null}
                destroyOnClose={true}
            >
                <div className="drawer-custom-header">
                    <div className="close-icon-wrapper" onClick={() => setAddClicked(false)}>
                        <BackArrow className="w-5 h-5" />
                    </div>
                    <div className="drawer-header-content">
                        <h2 className="drawer-title">Add New Store Location</h2>
                        <p className="drawer-subtitle">
                            Enter Store location info to help customers find you easily.
                        </p>
                    </div>
                </div>

                <AddNewLocation
                    allStores={allStores}
                    setLocations={setLocations}
                    setSelectedLocations={setSelectedLocations}
                    setSelectedLocationIds={setSelectedLocationIds}
                    setLocationNames={setLocationNames}
                    selectedMerchant={selectedMerchant}
                    onSuccess={() => setAddClicked(false)}
                    isDrawer={true}
                />
            </Drawer>

            <Drawer
                placement="right"
                onClose={() => setCsvDrawerOpen(false)}
                open={csvDrawerOpen}
                width={window.innerWidth < 640 ? "100%" : 520}
                className="add-store-drawer csv-upload-sidebar"
                rootClassName="modern-drawer-root"
                closeIcon={null}
            >
                <div className="drawer-custom-header">
                    <div className="close-icon-wrapper" onClick={() => setCsvDrawerOpen(false)}>
                        <BackArrow className="w-5 h-5" />
                    </div>
                    <div className="drawer-header-content">
                        <h2 className="drawer-title">Upload Locations via CSV</h2>
                        <p className="drawer-subtitle">
                            Quickly add multiple store locations by uploading a CSV file.
                        </p>
                    </div>
                </div>

                <UploadCSVDrawer
                    onClose={() => setCsvDrawerOpen(false)}
                    onUploadSuccess={(e) => {
                        handleAcceptedFiles(e);
                    }}
                    isSubmitting={fileloading}
                    locations={locations}
                    csvLocations={csvLocations} // Pass separate CSV locations
                    selectedLocationIds={tempCsvSelection} // Pass STAGING selection
                    onSelectionChange={handleTempSelectionToggle}
                    onBatchSelectionChange={handleBatchTempSelection}
                    onClear={handleClear}
                    onConfirm={handleConfirmAdd}
                />
            </Drawer>
        </div >
    );
};

export default Location;
